import { useCallback } from "react";
import { Button, DialogActions, DialogContent } from "@mui/material";

import PlantSearchResultTable from "../PlantSearchResultTable/PlantSearchResultTable";
import { useVrsTranslationState } from "../../../context/AppContext/AppContext";
import { DialogWithBackdropClick } from "../../DialogWithBackdropClick/DialogWithBackdropClick";

import { styled } from "@mui/material/styles";
import { StyledDialogTitle } from "../../../components/StyledDialogTitle/StyledDialogTitle";

const ContentContainer = styled("div")(() => ({
  justifyContent: "space-between",
  marginBottom: "20px",
}));

export const ActionButtonsContainer = styled(DialogActions)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
});

interface PlantSearchMenuProps {
  plants: Array<any>;
  onPlantSearchSelectionChanged: (plant: any) => void;
  plantSelectionMenu: any;
  setPlantSelectionMenu: any;
}

function PlantSearchMenu({
  plants,
  onPlantSearchSelectionChanged,
  plantSelectionMenu,
  setPlantSelectionMenu,
}: PlantSearchMenuProps) {
  const { _T } = useVrsTranslationState();

  const onCloseMenu = useCallback(() => {
    setPlantSelectionMenu(null);
  }, [setPlantSelectionMenu]);

  const applyPlantSearchSelectionChanged = useCallback(
    (event) => {
      onPlantSearchSelectionChanged(event);
      setPlantSelectionMenu(null);
    },
    [setPlantSelectionMenu, onPlantSearchSelectionChanged]
  );

  return (
    <DialogWithBackdropClick
      id="plant-selection-dialog"
      open={Boolean(plantSelectionMenu)}
      onClose={() => setPlantSelectionMenu(null)}
      aria-labelledby="plant-selection-dialog"
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: (theme) => ({
          height: "400px",
          [theme.breakpoints.only("xs")]: {
            height: "300px",
            width: "90%",
            maxWidth: "400px",
          },
          [theme.breakpoints.up("lg")]: {
            maxWidth: "1200px",
            height: "600px",
          },
          [theme.breakpoints.up("xl")]: {
            maxWidth: "1400px",
            height: "700px",
          },
        }),
      }}
    >
      <StyledDialogTitle id="select-site-dialog-title">
        <div>{_T("Select a Site")}</div>
      </StyledDialogTitle>
      <DialogContent dividers>
        <ContentContainer>
          {plants && (
            <PlantSearchResultTable
              plants={plants}
              onPlantSearchSelectionChanged={applyPlantSearchSelectionChanged}
            />
          )}
        </ContentContainer>
      </DialogContent>

      <ActionButtonsContainer>
        <Button id="close-btn" variant="contained" onClick={onCloseMenu}>
          {_T("Close")}
        </Button>
      </ActionButtonsContainer>
    </DialogWithBackdropClick>
  );
}

PlantSearchMenu.displayName = "PlantSearchMenu";

export { PlantSearchMenu };
